import React from "react";
import "../../../Styles/Story.css";

const STORY_DATA = [
  {
    title: "What is Elumia?",
    content:
      "Elumia is the UAE’s premier Smart Marketplace for Clinics, Medical and Pharma Suppliers. We are an all-in-one digital ecosystem that provides the convenience of a modern marketplace with the precision and reliability of an elite medical distributor.",
  },
  {
    title: "Ultimate Clinical Access",
    content:
      "Elumia is your single gateway to the finest medical and aesthetic supplies in the region. Instead of managing dozens of different vendors, you can procure everything—from premium injectables to daily consumables—through one professional digital portal. Our goal is to position Elumia as the center of the universe for every clinic.",
  },
  {
    title: "Guaranteed Price Integrity",
    content:
      "We have pioneered a transparent pricing model. By working directly with top-tier manufacturers, we have locked in fixed, competitive rates. This means the price you see is final—no more time-consuming negotiations or hidden costs. You get the best market value instantly, positioning Elumia as the fair-price defender for clinics.",
  },
  {
    title: "Operational Excellence",
    content:
      "Elumia gives you your time back. Our platform handles compliance, logistics, and supply chain complexities. With a 10-second ordering process and our rapid delivery network, your staff can stop worrying about inventory and focus entirely on patient care. Elumia acts as an assistant manager for your clinic.",
  },
];


const FAQ_DATA = [
  {
    question: "Who is Elumia?",
    answer:
      "We are the UAE’s tech-driven clinical procurement partner, simplifying how healthcare providers source their supplies.",
  },
  {
    question: "What makes you different?",
    answer:
      "We combine a massive digital product range with offline, relationship-driven support and a 48-hour delivery guarantee.",
  },
  {
    question: "Is it safe?",
    answer:
      "Absolutely. Our Chief Product Compliance Officer ensures every SKU is MOHAP-compliant and meets the highest regulatory standards.",
  },
  {
    question: "What is the cost?",
    answer:
      "There is no membership fee for clinics. You get the platform, the transparency, and the logistics support for free.",
  },
];

function Story() {
  return (
    <div className="story-container">
      <header className="story-header">
        <h1>Our Story</h1>
        <p>
          Elumia is transforming how clinics source medical and aesthetic
          supplies through technology, transparency, and operational excellence.
        </p>
      </header>

         {/* Story Section */}
      <div className="story-list">
        {STORY_DATA.map((item, index) => (
          <div className="story-card" key={index}>
            <h2>{item.title}</h2>
            <p>{item.content}</p>
          </div>
        ))}
      </div>

       {/* FAQ Section */}
      <div className="faq-section">
        {FAQ_DATA.map((item, index) => (
          <div className="faq-row" key={index}>
            <div className="faq-question">
              <h3>"{item.question}"</h3>
            </div>
            <div className="faq-answer">
              <p>"{item.answer}"</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Story;